import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { alert_error, alert_success } from '../../AppContext';
import { Cookies } from '../../index.js';
import Orders from "../../order/orders/orders.jsx";

export default function NhatkyordersSearch({ nutxuly, setnutxuly, inputlienket, setinputlienket }) {
  const [buttonTextjop, setbuttonTextjop] = useState("Xác nhận");
  const { slug_3 } = useParams();
  const ordersKey = slug_3 || "default";
  const descriptionBySlug = {
    home: "Cổng thông tin tổng hợp dữ liệu định danh",
    number: "Phân tích rủi ro SĐT và Tài khoản ngân hàng",
    social: "Truy vết hồ sơ và hoạt động trên mạng xã hội",
    website: "Kiểm tra độ uy tín của Website và Email",
  };
  const descriptionText = descriptionBySlug[slug_3] || "Tra cứu và xác thực thông tin định danh (SĐT, STK) dựa trên cơ sở dữ liệu rủi ro";

  // Giữ nguyên logic xử lý của bạn
  async function handleSubmit(e) {
    e.preventDefault();
    const myCookieValue = Cookies.get('apikey');
    setnutxuly(1);
    setbuttonTextjop('Please wait a moment 😊');

    if (!inputlienket) {
      alert_error('Please điền đầy đủ thông tin');
      setnutxuly(0);
      setbuttonTextjop('Xác nhận');
      return;
    }
    if (inputlienket.length < 2) {
      alert_error('Từ khóa phải có ít nhất 2 ký tự');
      setnutxuly(0);
      setbuttonTextjop('Xác nhận');
      return;
    }
    setbuttonTextjop('Xác nhận');
  }

  return (
    <div className="relative min-h-[80vh] w-full overflow-hidden bg-slate-50">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;600;700&display=swap');
      `}</style>

      {/* Hiệu ứng nền mờ ảo (Giữ lại cho đẹp) */}
      <div className="pointer-events-none absolute top-0 left-1/2 h-96 w-96 -translate-x-1/2 rounded-full bg-blue-400/20 blur-[120px]" />
      <div className="pointer-events-none absolute bottom-0 right-0 h-64 w-64 rounded-full bg-pink-400/20 blur-[100px]" />

      <div
        className="relative z-10 mx-auto w-full max-w-3xl py-8"
        style={{ fontFamily: "'Space Grotesk', 'Sora', sans-serif" }}
      >
        {/* --- HERO SECTION (HEADER) --- */}
        <div className="mb-8 text-center px-4">
          <div className="mb-4 inline-flex items-center justify-center rounded-2xl bg-white p-3 shadow-md shadow-blue-100/50">
             <span className="text-4xl">🛡️</span>
          </div>
          
          <h1 className="mb-2 text-3xl font-extrabold text-slate-900 md:text-4xl tracking-tight">
            Identity Verification Portal
          </h1>
          
          <p className="mx-auto max-w-xl text-base text-slate-500">
            {descriptionText}{" "}
            <span className="font-bold text-blue-600">Threat Intelligence</span>.
          </p>

          <div className="mt-4 flex flex-wrap justify-center gap-2">
             <span className="inline-flex items-center rounded-full bg-green-100 px-3 py-1 text-xs font-bold text-green-700">
                ● Real-time Database
              </span>
              <span className="inline-flex items-center rounded-full bg-purple-100 px-3 py-1 text-xs font-bold text-purple-700">
                ● AI Powered Analysis
              </span>
          </div>
        </div>

        {/* --- FORM CONTAINER (PHẦN QUAN TRỌNG NHẤT) --- */}
        {/* Sửa lỗi méo: Dùng bg-white + shadow để cô lập phần form cũ */}
        <div className="overflow-hidden rounded-2xl bg-white shadow-xl shadow-slate-200/60 ring-1 ring-slate-200">
          
          {/* Thanh trang trí trên cùng của form */}
          <div className="h-1.5 w-full bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500"></div>
          
          <div className="p-0 md:p-8">
             {/* Component Orders của bạn được đặt ở đây. 
                 Nền trắng sẽ giúp nó hiển thị đúng chuẩn, không bị lỗi màu text */}
             <Orders key={ordersKey} category_main='scams_check' api_categorymini={slug_3} servicecode='checks_search' />
          </div>
          
          <div className="bg-slate-50 px-6 py-3 text-center">
             <p className="text-xs text-slate-400 italic">
               * Hệ thống sử dụng thuật toán đối sánh mẫu (Pattern Matching) để phát hiện rủi ro.
             </p>
          </div>
        </div>

      </div>
    </div>
  );
}
